<template>
    <div>
        <div class="banner">
            <div class="swiper-wrapper">
                <div class="swiper-slide"><img src="@/assets/goyb02.png" alt="" /></div>
                <div class="swiper-slide"><img src="@/assets/goyb03.png" alt="" /></div>
                <div class="swiper-slide"><img src="@/assets/goyb01.png" alt="" /></div>
            </div>
            <!-- 如果需要分页器 -->
            <!-- <div class="swiper-pagination"></div> -->

            <!-- 如果需要导航按钮 -->
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
        </div>
        <div class="section wow animate__animated animate__fadeInUp" data-wow-duration="1s" style="background: #ededed;">
        <div class="section-title">公司年会</div>
        <div class="dual-card">
            <div class="gallery-img wow animate__animated animate__fadeInLeft" data-wow-delay="0.2s">
                <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-28-13-45-31-69120260131002.jpg" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInRight" data-wow-delay="0.2s">
                <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-28-13-40-21-28920260131004.jpg" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInLeft" data-wow-delay="0.4s">
                <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-28-13-46-47-74620260131005.jpg" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInRight" data-wow-delay="0.4s">
                <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-28-13-47-01-50720260131006.jpg" alt="">
            </div>
        </div>
        <div class="section-footer-text">
            ❤️ 总结年度工作成果，领导层述职汇报，表彰优秀员工，规划未来战略并开展全员拓展。
        </div>
    </div>
        <div class="section wow animate__animated animate__fadeInUp" data-wow-duration="1s">
        <div class="section-title">节日慰问</div>
        <div class="dual-card">
            <div class="gallery-img wow animate__animated animate__fadeInLeft" data-wow-delay="0.2s">
                <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-28-13-49-43-166%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20250430100604.jpg" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInRight" data-wow-delay="0.2s">
                <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-28-13-50-09-107%E4%B8%AD%E6%9C%BA%E5%85%AD%E9%99%A2.jpg" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInLeft" data-wow-delay="0.4s">
                <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-28-13-53-25-59808.jpg" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInRight" data-wow-delay="0.4s">
                <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-28-13-51-31-448%E6%81%92%E8%BE%BE5.jpg" alt="">
            </div>
        </div>
        <div class="section-footer-text">
            ❤️ 在春节、三八节、端午、中秋等节日为员工送上暖心礼品与文化活动。
        </div>
    </div>
        <!-- <div class="main3">
            <div class="title1">员工体检</div>
            <div class="content3">
                <div class="img3 wow animate__animated animate__fadeInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                    <img src="../../assets/active/12.jpg" alt="">
                </div>
                <div class="img3 wow animate__animated animate__fadeInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="1s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/active/13.jpg" alt="">
                </div>
            </div>
        </div> -->
        <div class="section wow animate__animated animate__fadeInUp" data-wow-duration="1s" style="background: #ededed;">
        <div class="section-title">员工体检</div>
        <div class="dual-card" style="grid-template-columns: repeat(3, 1fr);">
            <div class="gallery-img wow animate__animated animate__fadeInRight" data-wow-delay="0.2s">
                <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-28-13-55-18-409%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20260209144327_882_181.jpg" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInRight" data-wow-delay="0.3s">
                <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-28-13-55-42-740%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20260209152820_1636_21.jpg" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInRight" data-wow-delay="0.4s">
                <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-28-13-55-29-711%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20260209152809_1631_21.jpg" alt="">
            </div>
        </div>
        <div class="section-footer-text">
            ❤️ 公司每年组织全员健康体检，并为每位员工建立专属健康档案，守护职工健康。
        </div>
    </div>
    </div>
</template>

<script>
import Swiper from "swiper";
import { WOW } from 'wowjs'
export default {
    mounted() {
    //第一种写法，可以设置wow中属性
    this.$nextTick(() => { // 在dom渲染完后,再执行动画
    var wow = new WOW({
        boxClass: 'wow',///动画元件css类（默认为wow）
        animateClass: 'animated',//动画css类（默认为animated） 
        offset: 0,//到元素距离触发动画（当默认为0） 
        mobile: true, //在移动设备上触发动画（默认为true） 
        live: true//对异步加载的内容进行操作（默认为true）
    })
    wow.init()
    }),
    new Swiper(".banner",{
        loop:true, //循环模式选项

        // 如果需要分页器
        pagination:{
            el:".swiper-pagination",
        },
        // 如果需要前进后退按钮
        navigation:{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        // 如果需要滚动条
    //   scrollbar: {
    //     el: ".swiper-scrollbar",
    //   },

      autoplay: {
        autoplay: true, // 自动切换
        disableOnInteraction: false, // 点击之后重新计算
      },
    });
},
}
</script>

<style scoped>
.banner{
    width: 100%;
    height: 3.5rem;
    overflow: hidden;
}
/* .banner:hover img{
    transform: scale(1.2);
} */
.banner img{
    /* transition: all .4s; */
    width: 100%;
    height: 100%;
    /* display: block;
    object-fit: cover; */
}
.main1,
.main2{
    width: 100%;
    /* height: 3rem; */
    background-color: #ededed;
    /* margin: 20px auto; */
}
.title1{
    font-size: .1rem;
    font-weight: 700;
    padding: 20px 0;
}
.content1{
    width: 70%;
    /* height: 2.66rem; */
    margin: 0 auto;
    display: flex;
    /* background-color: green; */
    flex-wrap: wrap;
}
.img1,.img2{
    width: 50%;
    height: 375px;
}
img{
    width: 100%;
    height: 100%;
}
.text1{
    width: 50%;
    /* height: 2.66rem; */
    /* background-color: yellow; */
}
/* 第二部分 */
.main2{
    background-color: #fff;
}
.content2{
    width: 60%;
    height: 2.6rem;
    margin: 0 auto;
}
/* 第三部分 */
.main3{
    width: 100%;
    height: 2.85rem;
    background-color: #ededed;
}
.img3{
    width: 50%;
    height: 375px;
}
.content3{
    width: 70%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
}

.section {
            /* max-width: 1280px;
            margin: 0 auto;
            padding: 60px 24px; */

                padding: 0.3125rem 0.125rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
        }
        .section-title {
            text-align: center;
            font-size: 30px;
            font-weight: 700;
            margin-bottom: 48px;
            position: relative;
            letter-spacing: 2px;
        }
        .section-title:after {
            content: '';
            display: block;
            width: 80px;
            height: 4px;
            background: linear-gradient(90deg, #f97316, #facc15);
            margin: 16px auto 0;
            border-radius: 4px;
        }
        /* 网格布局（左右交替卡片） */
        .gallery-grid {
            display: flex;
            flex-direction: column;
            gap: 48px;
        }
        .gallery-row {
            display: flex;
            gap: 30px;
            align-items: center;
            background: #ffffff;
            border-radius: 32px;
            box-shadow: 0 20px 35px -12px rgba(0,0,0,0.1);
            overflow: hidden;
            transition: all 0.3s;
        }
        .gallery-row:hover {
            transform: translateY(-6px);
            box-shadow: 0 25px 40px -12px rgba(0,0,0,0.15);
        }
        .gallery-img {
            flex: 1;
            overflow: hidden;
            max-height: 350px;
        }
        .gallery-img img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.6s cubic-bezier(0.2, 0.9, 0.4, 1.1);
            display: block;
        }
        .gallery-row:hover .gallery-img img {
            transform: scale(1.05);
        }
        .gallery-desc {
            flex: 1;
            padding: 24px 32px;
        }
        .gallery-desc h3 {
            font-size: 24px;
            margin-bottom: 12px;
            color: #f97316;
        }
        .gallery-desc p {
            font-size: 16px;
            color: #475569;
            line-height: 1.6;
        }
        /* 交替方向 */
        .gallery-row.reverse {
            flex-direction: row-reverse;
        }
        /* 员工体检双卡片 */
        .dual-card {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 30px;
        }
        .dual-card .gallery-img {
            max-height: 380px;
            border-radius: 24px;
            overflow: hidden;
            box-shadow: 0 15px 25px -8px rgba(0,0,0,0.1);
        }
        .dual-card .gallery-img img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.4s;
        }
        .dual-card .gallery-img:hover img {
            transform: scale(1.03);
        }
        .section-footer-text {
            text-align: center;
            margin-top: 32px;
            color: #475569;
            font-size: 18px;
            padding: 0 20px;
        }
</style>